/**
 * Pagination component.
 */

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import setSearchUrl from '../actions/setSearchUrl';

class Pagination extends Component {

	constructor ( props ) {
		super();
		
		this.state = {
			pagination: []
		}
	}

	componentDidMount () {
		this.setPagination();
	}

	componentDidUpdate ( prevProps ) {
		if ( prevProps.state.currentPage !== this.props.state.currentPage ) {
			this.setPagination();
		}
	}

	/**
	 * Gedrag van paginering samenstellen.
	 * Gebaseerd op https://gist.github.com/kottenator/9d936eb3e4e3c3e02598.
	 */
	setPagination () {

		var current = this.props.state.currentPage;
		var last = this.props.state.totalPages;
		var delta = 1;
		var left = current - delta;
		var right = current + delta;
		var range = [];
		var rangeWithDots = [];
		var l;

		for ( let i = 1; i <= last; i++ ) {
			if ( i === 1 || i === last || ( i >= left && i <= right ) ) {
				range.push( i );
			}
		}

		for ( let i of range ) {
			if ( l ) {
				if ( i - l !== 1 ) {
					rangeWithDots.push( '...' );
				}
			}
			rangeWithDots.push( i );
			l = i;
		}

		this.setState( {
			pagination: rangeWithDots,
		} );
	}

	/**
	 * Utility function to generate correct pagination URL with params based on pagination number.
	 */
	generatePaginationUrl ( number ) {

		// We zetten de URL om naar parameters.
		let searchParameters = new URLSearchParams( this.props.state.paginationUrl );
		
		// We passen de parameter 'pagina' aan naar het juiste nummer.
		searchParameters.set( 'page', number );

		// We zetten de parameters terug om naar een URL.
		let newPaginationUrl = '?' + new URLSearchParams( searchParameters );

		// We sturen de URL terug.
		return newPaginationUrl;
	}

	render ( props ) {
		const { currentPage, totalPages } = this.props.state;
		const { pagination } = this.state;

		const handlePages = ( e ) => {
			e.preventDefault();

			let pageQuery = e.target.dataset.page;

			window.scrollTo( 0, 0 );

			this.props.dispatch( setSearchUrl( 'page', pageQuery ));
		}

		return (
			<Fragment>
				{ totalPages && totalPages > 1 ?
					<ol className="c-search__pagination c-pagination">

						{ currentPage > 1 && 0 !== ( currentPage - 1 ) &&

							<li className="c-pagination__prev">
								<a href={ this.generatePaginationUrl( currentPage - 1 ) } data-page={ currentPage - 1 } className="c-pagination__page" onClick={ e => { handlePages( e ); } }>Vorige</a>
							</li>
						}

						{ pagination.map( ( pageNum ) =>
							( pageNum === currentPage ?
								<li className="c-pagination__item c-pagination__active">
									<span className="c-pagination__page">{ pageNum }</span>
								</li>
								:
								<Fragment>
									{ '...' === pageNum ?
										<li className="c-pagination__item">
											<span className="c-pagination__page">{ pageNum }</span>
										</li> :
										<li className="c-pagination__item">
											<a href={ this.generatePaginationUrl( pageNum ) } data-page={ pageNum } className="c-pagination__page" onClick={ e => { handlePages( e ); } }>{ pageNum }</a>
										</li>
									}
								</Fragment>

							)
						) }
						{
							currentPage !== totalPages &&
							<li className="c-pagination__next">
								<a href={ this.generatePaginationUrl( currentPage + 1 ) } data-page={ currentPage + 1 } className="c-pagination__page" onClick={ e => { handlePages( e ); } }>Volgende</a>
							</li>
						}

					</ol>
					: <></>
				}
			</Fragment>
		)
	}
}

function mapStateToProps ( state ) {
	return { state };
}

export default connect( mapStateToProps )( Pagination );
